module.exports = ".splitter{\n    display: block;\n    height: calc(100vh - 59px);\n    top: 59px;\n    position: absolute;\n    width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main